import styles from './styles.module.scss'

function OrderPageSkeletonItem() {
  return (
    <div className={styles.OrderPageSkeleton_list}>
      <div className={`${styles.image} ${styles['skeleton-content']}`}></div>
      <div className={styles.details}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className={styles.reoder}></div>
    </div>
  )
}

export default function OrderPageSkeleton() {
  return (
    <div className={styles.OrderPageSkeleton}>
      <div className={styles.OrderPageSkeleton_header}>
        <div className={styles['skeleton-content']}></div>
        <div className={styles['skeleton-content']}></div>
        <div className={styles['skeleton-content']}></div>
      </div>
      <div className={styles.OrderPageSkeleton_summary}>
        <div className={styles['skeleton-content']}></div>
        <div className={styles['skeleton-content']}></div>
      </div>
      <div className={styles.OrderPageSkeleton_lists}>
        <OrderPageSkeletonItem />
        <OrderPageSkeletonItem />
        <OrderPageSkeletonItem />
      </div>
    </div>
  )
}
